import { Link } from "react-router-dom";
import { AddressBookPanel } from "../../components/admin/AddressBookPanel";

export function AdminAddressBookPage() {
  return (
    <div className="admin-page">
      <p className="admin-muted" style={{ marginBottom: 8 }}>
        <Link to="/admin/people">People</Link>
        {" · "}
        <Link to="/admin/communication">SMS compose</Link>
      </p>
      <AddressBookPanel />
    </div>
  );
}
